import React from 'react'
import { connect } from 'react-redux'
import { compose, withState, branch, withProps } from 'recompose'

import providesPaginatedApplications from 'components/Settings/Organization/Integrations/dataSync/providesPaginatedApplications'
import providesPaginatedIntegratedApplications from 'components/Integrations/dataSync/providesPaginatedIntegratedApplications'
import withGetApplicationInviteSettings from 'components/Integrations/dataSync/withGetApplicationInviteSettings'

import { selectors as UISelectors } from 'data/ui'
import { selectors as ApplicationsSelectors } from 'data/applications'
import { trackInviteSlackTeam } from 'data/analytics/actions'
import { selectors as OrganizationsSelectors } from 'data/organizations'
import { setActiveModal } from 'data/ui/actions'
import { selectors as ConfigSelectors } from 'data/config'
import { selectors as UserPreferencesSelectors } from 'data/userPreferences'

import { SLACK_INVITE } from 'components/Utils/Modal/constants'
import { Button } from 'components/base'
import CookiesHelpers from 'helpers/Cookies'
import RoutesHelper, { getAbsolutePath } from 'helpers/RoutesHelper'
import ModalWrapper from 'components/Utils/Modal/Wrapper'
import UserAssociationModal from 'components/Integrations/ShareTo/UserAssociationModal'
import { SlackIcon } from 'components/Utils/Icons'

class Slack extends React.Component {
  constructor(props) {
    super(props)
    this.handleInstallClick = this.handleInstallClick.bind(this)
  }

  state = {
    displayUserAssociationModal: false,
  }

  componentDidMount() {
    this.props.fetchNextPage({ startFresh: true })
    this.props.fetchApplicationsNextPage({ startFresh: true })
  }

  componentWillReceiveProps(nextProps) {
    const { inviteSettings, onboardingStep } = this.props
    // This is used when the user comes back from setting up the integration
    if (
      !inviteSettings &&
      nextProps.inviteSettings &&
      !nextProps.inviteSettings.needsUserAssociation &&
      onboardingStep === 'invite'
    ) {
      this.props.setActiveModal({
        id: SLACK_INVITE,
      })
    }
  }

  async handleInstallClick(event) {
    event.preventDefault()
    this.props.trackInviteSlackTeam()
    const {
      integration,
      inviteSettings,
      onboardingStep,
      application,
    } = this.props
    if (inviteSettings && inviteSettings.needsUserAssociation) {
      return this.setState({ displayUserAssociationModal: true })
    }
    if (integration) {
      return this.props.setActiveModal({
        id: SLACK_INVITE,
      })
    }

    const { cookieDomain, organizationId } = this.props

    CookiesHelpers.set('integrating-with-orgId', organizationId, {
      domain: cookieDomain,
    })

    window.location.href = getAbsolutePath(
      RoutesHelper.settingsIntegrationInstallApplication({
        applicationId: application.id,
        redirectUri:
          onboardingStep === 'invite'
            ? RoutesHelper.absoluteHome()
            : RoutesHelper.absoluteSettingsInvitations(),
      })
    )
  }

  handleUserAssociationDone = () => {
    this.setState({ displayUserAssociationModal: false })
    return this.props.setActiveModal({
      id: SLACK_INVITE,
    })
  }

  render() {
    const { application, clientId, apiEndpoint } = this.props
    let userAddUrl = ''
    if (this.state.displayUserAssociationModal) {
      userAddUrl = RoutesHelper.integrationUserAssociation({
        apiEndpoint,
        applicationClientId: clientId,
        onFinishedRedirectUrl: RoutesHelper.autoClosePopup(),
        associationRedirectUrl: this.props.inviteSettings.needsUserAssociation
          .redirectUrl,
      })
    }
    return (
      <React.Fragment>
        <Button.Secondary
          onClick={this.handleInstallClick}
          className="margin-bottom-large"
        >
          <div className="flexbox flexbox-align-center">
            <SlackIcon size={12} className="margin-right-normal" />
            Share invite link in Slack
          </div>
        </Button.Secondary>
        {this.state.displayUserAssociationModal && (
          <ModalWrapper
            isOpen={true}
            onRequestClose={this.props.onModalClose}
            size={262}
          >
            <UserAssociationModal
              onUserAssociationDone={this.handleUserAssociationDone}
              application={application.toJS()}
              userAddUrl={userAddUrl}
            />
          </ModalWrapper>
        )}
      </React.Fragment>
    )
  }
}

export default compose(
  providesPaginatedApplications(),
  withProps(({ fetchNextPage }) => ({
    fetchApplicationsNextPage: fetchNextPage,
  })),
  providesPaginatedIntegratedApplications(),
  withState('inviteSettings', 'setInviteSettings', null),
  connect(
    state => {
      const clientId = ConfigSelectors.getSlackAppSliteClientId(state)
      const application = ApplicationsSelectors.getApplication(state, clientId)
      const integrations = ApplicationsSelectors.getIntegrations(state)
      const integration =
        application &&
        integrations.find(
          integration =>
            integration.get('application').id === application.get('id')
        )
      return {
        cookieDomain: ConfigSelectors.getCookieDomain(state),
        organizationId: OrganizationsSelectors.getOrganizationId(state),
        application,
        integration: integration && integration.toJS(),
        clientId,
        activeUserId: UISelectors.getActiveUserId(state),
        apiEndpoint: ConfigSelectors.getApiEndpoint(state),
        onboardingStep: UserPreferencesSelectors.getUserPreferences(state).get(
          'onboardingStep'
        ),
      }
    },
    { setActiveModal, trackInviteSlackTeam }
  ),
  branch(
    props => Boolean(props.integration),
    withGetApplicationInviteSettings({
      viewName: 'loadInviteSettings',
      queryOnChanges: true,
      mapPropsToVariables({ integration }) {
        return {
          clientId: integration.application.id,
        }
      },
      onInviteSettingsFetched: ({ setInviteSettings }, data) =>
        setInviteSettings(data),
    })
  )
)(Slack)
